module.exports = __webpack_public_path__ + "static/media/my-list-tip.b4faeb9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/my-list-tip.png
// module id = 2039
// module chunks = 6